import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuyComponent } from './buy/buy.component';
import { CtaMainComponent } from './cta-main.component';
import { DocumentsUploadComponent } from './documents-upload/documents-upload.component';

const routes: Routes = [
  {
    path: '',
    component: CtaMainComponent,
    children: [
      { path: 'buy-gap', component: BuyComponent },
      { path: 'buy-gap/:affiliationLink', component: BuyComponent },
      { path: 'upload/:policyNo', component: DocumentsUploadComponent },
      { path: '**', redirectTo: 'buy-gap' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CtaRoutingModule {}
